import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/data'
import { Schema } from "../amplify/data-resource";
import { Logger } from "tslog";
import { BackendRequest, BackendResponse } from '../amplify/types';
import {Utils} from '../utils/amplify-utils';

@Injectable({
  providedIn: 'root'
})

export class AmplifyService {
  private log = new Logger({minLevel: Utils.GLOBAL_LOG_LEVEL});
  
  private amplifyClient = generateClient<Schema>({
    authMode: 'userPool',
  });

  public getClient(): typeof this.amplifyClient {
    return this.amplifyClient;
  }


  public async sendGenericBackendRequest(request:BackendRequest):Promise<BackendResponse>{
    console.log('Send request!',request);
    const response = await this.amplifyClient.queries.journeyFunctions({request:JSON.stringify(request)});
    console.log('got data',response);
    const responseData = Utils.getDataFromResult(response.data,response.errors,`Error => ${request.type}`);
    if(!responseData) throw `Could not ${request.type} => null`;
    console.log('Response data =>',responseData);
    let jsonObj;
    try{
      console.log('willparse');
      jsonObj = JSON.parse(responseData);
      console.log('parsed',jsonObj);
    }catch(err){
      console.log(err);
    }

    return jsonObj as BackendResponse;
  }
}
